import { EVENT_CODES_LOOKUP_TABLE } from '../constants';

export const mapUserActivities = (userActivities, t) => {
  return userActivities.map(userActivity => {
    return {
      ...userActivity,
      typeCode: userActivity.type,
      type: t(EVENT_CODES_LOOKUP_TABLE[userActivity.type]),
    };
  });
};
